import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { Info } from "lucide-react";
import { SectionTitle } from "./Sections";

export const DosageTable = () => {
  const { t } = useTranslation();
  const rows = t("dosage.rows", { returnObjects: true });
  return (
    <section id="dosage" className="bg-brand-cream py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <SectionTitle title={t("dosage.title")} subtitle={t("dosage.subtitle")} />
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="overflow-x-auto rounded-3xl border border-brand-green/15 shadow-[0_8px_30px_rgba(109,76,65,0.08)] bg-white">
          <table data-testid="dosage-table" className="w-full text-start min-w-[560px]">
            <thead>
              <tr className="bg-brand-dark text-brand-yellow">
                <th className="text-start px-6 py-4 font-heading text-lg uppercase tracking-wide">{t("dosage.crop")}</th>
                <th className="text-start px-6 py-4 font-heading text-lg uppercase tracking-wide">{t("dosage.time")}</th>
                <th className="text-start px-6 py-4 font-heading text-lg uppercase tracking-wide">{t("dosage.dose")}</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={i} className={i % 2 === 0 ? "bg-white" : "bg-brand-cream"}>
                  <td className="px-6 py-4 text-sm font-bold text-brand-dark">{r.crop}</td>
                  <td className="px-6 py-4 text-sm text-brand-brown">{r.time}</td>
                  <td className="px-6 py-4 text-sm text-brand-brown font-semibold">{r.dose}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </motion.div>
        <p className="mt-4 flex items-start gap-2 text-xs text-brand-brown/80 font-semibold max-w-2xl">
          <Info size={14} className="shrink-0 mt-0.5 text-brand-green" /> {t("dosage.note")}
        </p>
      </div>
    </section>
  );
};
